export default {
  unsaved: {
    title: 'Salvare le modifiche?',
    description: 'Hai apportato modifiche a questo passaggio non ancora salvate.',
    discard: 'Ignora',
    save_and_continue: 'Salva e continua',
  },
  title: 'Configura il tuo ristorante',
  nav: {
    completed: 'Completato',
    locked: 'Gestito dal tuo provider',
    aria_label: 'Passaggi di avvio',
    step_label: 'Passaggio {{number}}',
    section_label: 'Avvio',
    back_to_home: 'Torna alla home',
  },
  owner_invite: {
    hint: 'Preferisci che il titolare del ristorante completi la configurazione? Invitalo e riprenderà da dove hai lasciato.',
    sent: 'Invito inviato a {{name}} ({{email}}) il {{date}}.',
  },
  footer: {
    step_of: 'Passaggio {{current}} di {{total}}',
  },
  buttons: {
    next_task: 'Prossima attività',
    cancel: 'Annulla',
    back: 'Indietro',
    next: 'Continua',
    save: 'Salva',
    exit: 'Esci dalla configurazione',
    retry: 'Riprova',
  },
  errors: {
    progress_load_failed: "Impossibile caricare l'avanzamento della configurazione per questo ristorante.",
    linked_company_unavailable: 'Questo link è per un ristorante che non puoi aprire, quindi sei su quello attuale.',
  },
  placeholder: {
    title: 'Questo passaggio sarà disponibile a breve',
    description:
      "La shell del wizard e il tracciamento dell'avanzamento sono pronti. Questa fase verrà sviluppata successivamente.",
  },
  new_restaurant: {
    title: 'Nuovo ristorante',
    menu: {
      title: 'Menu',
      description: "Un demo salta l'onboarding, quindi importa subito il suo menu.",
    },
    demo: {
      title: 'Nuovo demo',
      description: "Un ristorante demo per i test — salta la maggior parte dell'onboarding.",
      label: 'Crea demo',
    },
    description: 'Dicci dove si trova questo ristorante. Lo cercheremo su Google Maps.',
  },
  location: {
    edit_description: 'Aggiorna la posizione di questo ristorante.',
    cta: 'Crea ristorante',
    section: {
      address: 'Informazioni di base',
      group: 'Marchio',
      group_description: 'Questa sede fa parte di un marchio già esistente?',
    },
    form: {
      name: {
        label: 'Nome del ristorante',
        placeholder: 'Cerca il tuo ristorante…',
        help: 'Inizia a digitare per cercare questo ristorante su Google Maps.',
      },
      address: {
        label: 'Indirizzo',
        placeholder: 'Via e numero',
      },
      city: {
        label: 'Città',
      },
      zip_code: {
        label: 'CAP',
      },
      country: {
        label: 'Paese',
      },
      region: {
        label: 'Stato / Regione',
        placeholder: 'Seleziona uno stato o una regione',
      },
    },
    group: {
      aria_label: 'Opzioni marchio',
      deferred_hint: "Sceglierai il nome del marchio e l'indirizzo web nell'ultimo passaggio.",
      existing: {
        title: 'Aggiungi a un marchio esistente',
        description: "Un'altra sede di un marchio che già gestisci.",
        select_label: 'Marchio',
        select_placeholder: 'Seleziona un marchio',
      },
      new: {
        title: 'Crea un nuovo marchio',
        description: 'Un singolo ristorante, oppure la prima sede di un nuovo marchio.',
      },
    },
    toasts: {
      update_failed: 'Impossibile salvare la posizione. Riprova.',
      created: 'Ristorante creato',
      create_failed: 'Impossibile creare il ristorante. Riprova.',
    },
  },
  domain: {
    url_setup: {
      title: 'Indirizzo per gli ordini online',
      description: 'Dove i clienti effettueranno gli ordini.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'il tuo dominio per gli ordini online',
        title: 'Usa il nostro dominio generico',
      },
      custom: {
        title: 'Collega il tuo dominio',
        description: 'Usa un dominio già di proprietà del ristorante.',
      },
    },
    toasts: {
      save_failed: "Impossibile salvare l'indirizzo per gli ordini online. Riprova.",
    },
  },
  go_live: {
    subtitle: 'Verifica che ogni passaggio sia completato, poi attiva gli ordini live.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Solo lettere, numeri e trattini. Puoi modificarlo in seguito, ma il vecchio indirizzo smetterà di funzionare.',
      title: 'Indirizzo per gli ordini online',
      description: 'Qui i tuoi clienti effettueranno gli ordini. Puoi modificarlo in seguito.',
      label: 'Personalizzalo con il nome del ristorante',
      placeholder: 'bella-italia',
      preview: 'La tua pagina ordini:',
      save: 'Salva URL',
      saved: 'Indirizzo per gli ordini online salvato',
      save_failed: "Impossibile salvare l'URL. Riprova.",
      status: {
        checking: 'Verifica disponibilità…',
        available: 'Disponibile',
        taken: 'Questo URL è già in uso',
        invalid: 'Usa solo lettere, numeri, trattini e underscore',
        error: 'Impossibile verificare la disponibilità — riprova',
      },
    },
    domain: {
      title: 'Dominio personalizzato (opzionale)',
      description: "Usa il tuo dominio invece dell'indirizzo fornito da FoodAmigos.",
      add: '+ Aggiungi un dominio personalizzato',
      hide: 'Nascondi dominio personalizzato',
      label: 'Il tuo dominio',
      placeholder: 'shop.mioristorante.com',
      save: 'Salva',
      show_records: 'Mostra record DNS',
      hint: 'Solo per gli ordini — il tuo sito web ha bisogno di un altro dominio. Ad esempio order.ilmioristorante.com per il negozio e ilmioristorante.com per il sito web.',
      records_after_save:
        'Appena salvi il dominio, ti mostriamo i record esatti da aggiungere presso il tuo provider DNS — un dominio principale (ilmioristorante.com) e un sottodominio (order.ilmioristorante.com) ne richiedono di diversi.',
      saved: 'Dominio personalizzato salvato',
      save_failed: 'Impossibile salvare il dominio. Riprova.',
      unconfirmed: {
        title: 'La pubblicazione non attende questo dominio',
        description:
          'Finché i suoi record non sono confermati, la pagina ordini resta sul suo indirizzo standard e il ristorante può andare live lì. Una volta confermati — può richiedere fino a 48 ore — il dominio mostrerà automaticamente la pagina ordini.',
      },
    },
    locations: {
      title: 'Conferma le sedi',
      description: 'Ogni sede del tuo marchio ha il proprio indirizzo per gli ordini. Conferma o modificali qui sotto.',
      save: 'Salva sedi',
      saved: 'URL delle sedi salvati',
      save_failed: 'Impossibile salvare uno o più URL delle sedi. Riprova.',
    },
    preflight: {
      title: 'Prima di andare live',
      description: 'Completa questi passaggi per abilitare gli ordini live.',
      url_setup: 'Indirizzo ordini configurato',
      online_payment: {
        your_provider: 'il tuo provider',
        payments_live: '{{title}} · completato',
        online_payments_off: '{{title}} · pagamenti online non attivi',
        waiting_for_provider: '{{title}} · in attesa di {{provider}}',
        hosted_not_finished: '{{title}} · completa con {{provider}}',
        action_needed: '{{title}} · azione richiesta',
        waiting_for_partner: '{{title}} · in attesa del tuo partner',
        not_set_up: '{{title}} · non configurato',
        business_details_missing: '{{title}} · aggiungi i dati aziendali per i pagamenti',
      },
    },
    failed_checks: {
      title: 'Alcuni elementi richiedono ancora attenzione',
      items: {
        name: 'Nome del ristorante',
        logo_url: 'Logo',
        pictures: 'Foto galleria',
        menu_uploaded: 'Menu',
        opening_hours: 'Orari di apertura',
        address: 'Indirizzo',
        storefront: 'Indirizzo ordini',
        payments_configured: 'Pagamenti',
        stripe_billing: 'Fatturazione',
        test_orders: 'Ordine di prova',
        google_business: 'Profilo Google Business',
        master_promo_code: 'Codice promo di benvenuto',
        flyers_ordered: 'Volantini ordinati',
        identity: 'Tipo di ristorante e cucine',
        billing_payment_method: 'Metodo di pagamento',
        billing_license: 'Licenza',
        business_name: "Nome dell'azienda / del ristorante",
        payment_method: 'Contanti o pagamenti online',
        stripe_processing_fee: 'Commissione di elaborazione del partner',
      },
      force: 'Vai live comunque',
      blocker: '(obbligatorio)',
      link: 'Apri Fatturazione Partner',
    },
    error: 'Impossibile abilitare gli ordini live. Riprova.',
    gate_hint: 'Completa la checklist sopra per abilitare il Go Live.',
    business_name: {
      label: "Nome dell'azienda / del ristorante",
      help: "Compare nelle tue condizioni d'uso e nella tua informativa sulla privacy. Usa il nome con cui opera la tua attività.",
      save: 'Salva',
      save_failed: "Impossibile salvare il nome dell'azienda. Riprova.",
      hint: "Salva prima il nome dell'azienda / del ristorante.",
    },
    cash_only: {
      message:
        'I pagamenti online sono disattivati: i clienti possono pagare solo in contanti al ritiro o alla consegna finché un gateway non è collegato e verificato.',
    },
    payment_blocked: {
      title: 'Attiva i pagamenti in contanti o configura i pagamenti online per andare live.',
      payment_method: 'I clienti hanno bisogno di un modo per pagare.',
      turn_on_cash: 'Attiva i pagamenti in contanti',
      ask_partner: 'Chiedi al tuo partner di attivare i pagamenti in contanti, oppure',
      set_up_online: 'configura i pagamenti online',
    },
    buttons: {
      go_live: 'Go Live 🚀',
      finish: 'Completa la configurazione',
    },
    celebration: {
      title: 'Sei live!',
      title_named: '{{name}} è online!',
      subtitle: 'Il tuo ristorante accetta ora ordini live.',
      license: '{{plan}} · attivo',
      license_trial: '{{plan}} · gratis fino al {{date}}',
      finish: 'Completa la configurazione',
    },
    service_fee: {
      title: 'Commissione di servizio',
      headline: 'Guadagna entrate extra senza far pagare i tuoi ristoranti',
      subtitle:
        'Aggiungi una piccola commissione di servizio che gli ospiti pagano al checkout. Tu ne trattieni la metà. Resta disattivata finché non la attivi.',
      subtitle_share:
        'Aggiungi una piccola commissione di servizio che gli ospiti pagano al checkout. Tu ne trattieni il {{share}}%. Resta disattivata finché non la attivi.',
      tiles: {
        guest: {
          title: "Pagata dall'ospite",
          description: 'Mostrata al checkout, come nelle app di delivery.',
        },
        share: {
          title: 'Metà va a te',
          title_share: 'Il {{share}}% va a te',
          description: 'Ripartizione {{share}}/{{rest}} con FoodAmigos.',
        },
        choice: {
          title: 'Scegli tu',
          description: 'Disattivata di default. Modificala quando vuoi.',
        },
      },
      preview: {
        title: 'Cosa vedrebbero gli ospiti al checkout',
        subtotal: 'Subtotale ordine',
        fee: 'Commissione di servizio',
        fee_terms: '({{percentage}}%, max {{max}})',
        guest_pays: "L'ospite paga",
        split_partner: '<strong>Tu {{amount}}</strong> per ordine',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: "Il valore dell'ordine del ristorante non cambia.",
      },
      earnings: {
        title: 'Cosa potresti guadagnare da questo ristorante',
        orders: 'Ordini online al mese',
        average_order: 'Ordine medio',
        per_month: 'al mese per te',
        collected: '{{amount}} incassati dagli ospiti al mese. La tua quota: {{share}}%. Solo una stima.',
        effective_rate: 'Aliquota effettiva della commissione su tutti gli ordini: {{rate}}',
      },
      choice: {
        question: 'Aggiungere una commissione di servizio per questo ristorante?',
        enabled: {
          title: 'Aggiungi una commissione di servizio',
          recommended: 'Consigliato: {{percentage}}%, max {{max}}',
          description: 'Gli ospiti pagano una piccola commissione. Tu guadagni una quota.',
        },
        skipped: {
          title: 'Nessuna commissione di servizio',
          description: 'Gli ospiti pagano solo i prezzi del menu.',
        },
      },
      footer: {
        enabled:
          'Gli ospiti pagano il {{percentage}}%, max {{max}} per ordine. Modificala quando vuoi in <settings>Impostazioni ordini → Commissione di servizio</settings>.',
        skipped:
          'Per ora nessuna commissione di servizio. Modificala quando vuoi in <settings>Impostazioni ordini → Commissione di servizio</settings>.',
      },
      enabled:
        'Il costo del servizio è ora attivo su questo ristorante al {{percentage}}%, con un massimo di {{max}} per ordine. Si applica a tutti i nuovi ordini da ora in poi. Puoi modificarlo in qualsiasi momento in <settings>Impostazioni ordini → Costo del servizio</settings>.',
      enabled_partner_default:
        'Il costo del servizio è ora attivo su questo ristorante. Si applica il tuo valore predefinito del partner: {{percentage}}%, con un massimo di {{max}} per ordine. Si applica a tutti i nuovi ordini da ora in poi. Puoi modificarlo in qualsiasi momento in <settings>Impostazioni ordini → Costo del servizio</settings>.',
      buttons: {
        enable: 'Attiva commissione di servizio',
        continue_without: 'Continua senza commissione',
      },
      skipped:
        'Gli ospiti di questo ristorante non pagano alcun costo del servizio. Puoi attivarlo in qualsiasi momento in <settings>Impostazioni ordini → Costo del servizio</settings>.',
      toasts: {
        save_failed: 'Impossibile salvare la scelta della commissione di servizio. Riprova.',
      },
    },
  },
  toasts: {
    save_failed: 'Impossibile salvare le modifiche. Riprova.',
    saved: 'Salvato',
  },
  optional: 'Facoltativo',
  identity: {
    min_cuisine_hint: 'Seleziona almeno una cucina per continuare.',
    sections: {
      restaurant_type: {
        title: 'Tipo di ristorante',
        description: 'Che tipo di locale è questo?',
      },
      cuisine: {
        title: 'Tipi di cucina',
        description: 'Selezionane almeno uno.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Consigliati',
      import: {
        title: 'Importa da una piattaforma',
        description: 'Importa il menu da Wolt, Lieferando, Deliveroo e altro.',
      },
      manual: {
        title: 'Crea il tuo menu da zero',
        description: 'Crea categorie e prodotti manualmente nel builder del menu.',
      },
    },
    import: {
      title: 'Importa da piattaforma esistente',
      in_progress: {
        title: 'Importazione menu in corso…',
        description: 'Di solito richiede meno di due minuti. Completeremo questo passaggio non appena termina.',
      },
      failed: {
        title: "L'importazione non è completata",
        description: "Impossibile completare l'importazione del menu. Controlla i dettagli e riprova.",
      },
      blocked: {
        until: 'In pausa fino a {{time}}',
        release: 'Rilascia il link',
        released: "Link rilasciato. Puoi riavviare l'importazione.",
        release_failed: 'Impossibile rilasciare il link. Riprova tra un attimo.',
      },
      stalled: {
        title: 'Importazione ancora in corso…',
        description:
          "L'importazione sta impiegando più del solito. Potrebbe essere ancora in esecuzione in background — ricontrolla tra poco. Avviare una nuova importazione ora potrebbe duplicare il menu.",
      },
    },
    manual: {
      title: 'Crea il tuo menu da zero',
      description:
        'Il builder del menu si apre con un menu vuoto. Questo passaggio è completo quando esiste almeno una categoria e un prodotto.',
      open_editor: 'Apri il builder del menu',
      waiting: {
        title: 'In attesa del primo prodotto del menu',
        description: "Una volta aggiunto un prodotto nell'editor del menu, questo passaggio sarà completato.",
      },
      found: {
        title: 'Prodotti del menu rilevati',
        description: 'Ottimo — puoi continuare al passaggio successivo.',
      },
    },
    complete: {
      title: 'Menu pronto',
      description: "Il tuo menu è configurato. Puoi rivederlo in qualsiasi momento dall'editor del menu.",
    },
    buttons: {
      start_import: 'Avvia importazione',
      importing: 'Importazione…',
      retry: 'Riprova importazione',
      check_again: 'Ricontrolla',
      continue: 'Continua',
      skip: 'Salta per ora',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'questo ristorante',
    location: {
      title: 'Sede',
      description: 'Dove si trova il ristorante e a quale marchio appartiene?',
    },
    identity: {
      title: 'Identità',
      description: 'Tipo di ristorante e cucine.',
    },
    brand: {
      title: 'Marchio',
      description: 'Logo, colori e galleria.',
    },
    operations: {
      title: 'Dettagli sede',
      description: 'Configura come {{name}} gestisce gli ordini. È il minimo richiesto prima di poter ricevere ordini.',
    },
    menu: {
      title: 'Menu',
      description:
        'Inserisci il menu di {{name}} sulla piattaforma. Importalo da una piattaforma esistente in meno di due minuti, oppure crealo da zero.',
    },
    domain: {
      title: 'Dominio',
      description: "L'indirizzo web che i clienti usano per ordinare da questo ristorante.",
    },
    go_live: {
      title: 'Go Live',
      description: 'Abilita gli ordini live.',
    },
    payouts: {
      title: 'Pagamento online',
      description: 'Come questo ristorante riceve i pagamenti online.',
    },
    service_fee: {
      title: 'Commissione di servizio',
      description:
        'Indica se gli ospiti pagano una commissione di servizio al checkout. Puoi modificarla in seguito in Impostazioni ordini → Commissioni.',
    },
    bank_account: {
      title: 'Conto bancario',
      description:
        'Dove vengono inviati i pagamenti. Non serve per andare online: i pagamenti restano nel saldo finché non viene aggiunto un conto.',
    },
  },
  business_details: {
    locked: 'Questi dati sono verificati con il tuo fornitore di pagamenti. Per modificarli, contatta FoodAmigos.',
    section: {
      title: 'Dati aziendali',
    },
    fields: {
      business_type: {
        label: 'Tipo di attività',
        options: {
          company: "Azienda (GmbH, UG, Ltd, Inc — un'entità giuridica registrata)",
          individual: "Ditta individuale (gestisci personalmente l'attività)",
        },
      },
      owner_first_name: { label: 'Nome del titolare' },
      owner_last_name: { label: 'Cognome del titolare' },
      legal_name: {
        label: 'Ragione sociale',
        individual: "Gestisci l'attività personalmente, quindi il nome del titolare viene usato come ragione sociale.",
      },
      legal_address: { label: 'Sede legale' },
      legal_city: { label: 'Città' },
      legal_state: { label: 'Stato o provincia' },
      legal_zip_code: { label: 'CAP' },
      legal_country: { label: 'Paese' },
      tax_id: {
        generic: 'Numero di partita IVA o registrazione',
        personal: 'Sono mostrate solo le ultime quattro cifre. Lascialo invariato per non modificare il numero.',
        hint: 'Ad esempio {{example}}.',
        invalid:
          'Questo non corrisponde al formato abituale per questo paese e tipo di attività, ad esempio {{example}}.',
      },
      is_vat_registered: { label: 'Questa attività ha partita IVA' },
      vat_id: {
        label: 'Partita IVA',
        help: 'Inizia con {{country}}, seguito da 8-12 lettere o cifre.',
        invalid: 'La partita IVA deve iniziare con {{country}}, seguito da 8-12 lettere o cifre.',
        help_unprefixed: 'Il tuo numero di partita IVA o di registrazione fiscale, così come rilasciato.',
        invalid_unprefixed: 'Non sembra un numero di partita IVA: usa da 5 a 25 lettere o cifre.',
      },
    },
    toasts: {
      save_failed: 'Impossibile salvare i dati aziendali. Riprova.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Nome breve',
        placeholder: 'es. Amigo Pizza',
        tooltip: 'Un nome breve usato nello storefront e nelle ricevute.',
      },
      primary_color: {
        label: 'Colore primario',
        invalid: 'Inserisci un colore esadecimale valido, es. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nome',
      short_name_hint: 'Usato nello storefront, nelle ricevute e nelle notifiche.',
      logo_and_colour: 'Logo e colore brand primario',
      logo: 'Carica logo',
      logo_hint: 'Se lasci questo campo vuoto, verrà utilizzato il logo del tuo marchio.',
      gallery: 'Foto galleria',
      gallery_hint: 'Aggiungi fino a {{max}} foto del tuo ristorante. Trascina per riordinare.',
      gallery_count: '{{count}} di {{max}} aggiunti',
    },
    toasts: {
      image_uploaded: 'Immagine caricata',
      image_upload_failed: "Impossibile caricare l'immagine. {{error}}",
      save_failed: 'Impossibile salvare i dati del brand. Riprova.',
    },
  },
  operations: {
    contact: {
      title: 'Contatto',
      description: 'Utilizzati per le notifiche degli ordini e le comunicazioni con i clienti.',
      phone: {
        label: 'Numero di telefono del ristorante',
        placeholder: '+49 30 1234567',
        invalid: 'Inserisci un numero di telefono internazionale completo, es. +49 30 1234567',
      },
      email: { label: 'Email del ristorante', placeholder: 'ordini@ristorante.com' },
    },
    methods: {
      title: 'Metodi di ordine',
      description: 'Come i clienti possono ordinare e i tempi di ogni metodo.',
      pickup: {
        label: 'Ritiro',
        prep_time: { label: 'Tempo medio di preparazione (min)' },
      },
      delivery: {
        label: 'Consegna',
        delivery_time: { label: 'Tempo medio di consegna (min)' },
        advanced_zones: 'Configurazione zone avanzata',
      },
    },
    timing: {
      title: 'Tempistiche ordini',
      description: 'Quando i clienti possono effettuare ordini — subito, dopo o in anticipo.',
      at_least_one: 'Attiva ordini immediati o programmati (almeno uno è obbligatorio).',
      asap: { label: 'Accetta ordini immediati' },
      scheduled: { label: 'Accetta ordini programmati' },
      reminders: { label: 'Invia un promemoria automatico prima della scadenza di un ordine programmato' },
      pre_order: {
        label: 'Consenti preordini per i giorni successivi',
        days: { label: 'Quanti giorni in anticipo (0–31)' },
      },
    },
    tax: {
      title: 'IVA',
      description:
        "L'aliquota applicata ai prodotti di questo ristorante. Parte dall'aliquota della regione — modificala solo se questo ristorante applica un'aliquota diversa.",
      rate: { label: 'Aliquota IVA', placeholder: 'es. 7' },
      dedicated: { label: "L'IVA varia in base al prodotto" },
    },
    hours: {
      title: 'Orari di apertura',
      description: 'I giorni e gli orari in cui questo ristorante accetta ordini.',
      same_every_day: 'Stesso orario ogni giorno',
      split_shifts: {
        title: 'Questo ristorante ha orari di apertura divisi',
        description:
          "Alcuni giorni hanno più di un periodo di apertura (ad esempio pranzo e cena). L'editor semplice mostra un solo periodo al giorno, quindi gli orari esistenti vengono mantenuti — modifica i turni divisi in Impostazioni ordini → Orari di apertura.",
      },
    },
    toasts: {
      save_failed: 'Impossibile salvare le impostazioni operative. Riprova.',
    },
  },
  online_payment: {
    question: 'Vuoi accettare pagamenti online per questo ristorante?',
    yes: 'Sì',
    not_now: 'Non ora',
    declined:
      'I clienti pagheranno al ritiro o alla consegna. Puoi attivare i pagamenti online in qualsiasi momento dalle Impostazioni.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'I pagamenti non sono ancora configurati per il tuo account partner',
        description:
          'Un amministratore del tuo account partner deve scegliere chi elabora i pagamenti prima che questo ristorante possa accettare pagamenti online. Nel frattempo puoi procedere con gli altri passaggi.',
      },
    },
    continue_to_go_live: 'Continua per andare live',
    platform_line: 'I pagamenti per questo ristorante passano tramite FoodAmigos payments.',
    only_connection: 'I pagamenti passano tramite {{name}} (il tuo unico provider collegato).',
    partner_issue: {
      title: 'Il tuo partner {{partner}} deve completare la configurazione del proprio provider di pagamento',
      description:
        'Il loro provider di pagamento non può ancora registrare ristoranti. Li abbiamo informati: i tuoi dati sono salvati, quindi torna quando confermeranno che è tutto pronto.',
      retry_hint: 'Una volta risolto, continua di nuovo verso il provider e riproveremo.',
      open_settings: 'Apri le impostazioni del gateway di pagamento',
    },
    connect_another: 'Collega un altro provider',
    checking: 'Verifica con {{provider}} in corso…',
    checking_generic: 'Verifica in corso con il fornitore di pagamento…',
    retry: 'Riprova',
    not_set_up: {
      title: 'Nessun fornitore di pagamento collegato',
      description:
        'Il tuo partner collega un fornitore di pagamento a questo ristorante. Una volta fatto, potrai completare la configurazione qui.',
    },
    choice: {
      title: 'Quale dei tuoi fornitori collegati dovrebbe usare questo ristorante?',
      primary: 'Principale',
      confirm: 'Usa questo fornitore',
      cancel: 'Annulla',
    },
    using: 'Utilizzo di {{name}}',
    change: 'Cambia',
    payout_details: {
      title: 'Dati aziendali per i pagamenti',
      description: 'Richiesti dal fornitore di pagamento per verificare la tua attività e inviare i pagamenti.',
      business_type: {
        company: {
          title: 'Azienda',
          description: 'GmbH, Srl, Ltd, Inc: una persona giuridica registrata',
        },
        individual: {
          title: 'Individuale',
          description: "Possiedi e gestisci personalmente l'attività",
        },
      },
      registered_address: 'Sede legale',
      legal_address: 'Indirizzo',
      legal_state: 'Stato / regione',
      vat_id: 'Partita IVA',
      optional: '(facoltativo)',
      fill_first: 'Compila prima i dati aziendali per i pagamenti qui sopra.',
    },
    hand_off: {
      title: 'Prossimo passo: completa la configurazione con {{provider}}',
      description:
        "{{provider}} chiederà il documento d'identità del titolare nel proprio modulo, usando i dati aziendali per i pagamenti indicati sopra. Circa 10 minuti. Il conto bancario arriva dopo la messa online.",
      cta: 'Continua su {{provider}}',
      transition: 'Ti stiamo reindirizzando a {{provider}}…',
      error: 'Non è stato possibile aprire il modulo {{provider}}. Riprova.',
    },
    states: {
      verified: 'I pagamenti sono attivi.',
      submitted: {
        title: 'Dettagli inviati a {{provider}}',
        description:
          "La verifica richiede solitamente 1–2 giorni lavorativi. Invieremo un'email al titolare del ristorante al termine.",
        description_email:
          "La verifica richiede solitamente 1–2 giorni lavorativi. Ti invieremo un'email a {{email}} al termine.",
        review: {
          business_type: 'Tipo di attività',
          legal_name: 'Ragione sociale',
          address: 'Sede legale',
          types: {
            company: 'Azienda',
            individual: 'Individuale',
          },
        },
      },
      incomplete: {
        title: 'Non hai completato la procedura con {{provider}}',
        description: 'I tuoi dati sono salvati — il link è valido per 2 giorni.',
        expired: 'I tuoi dati sono salvati, ma il link è scaduto.',
        cta: 'Continua con {{provider}}',
        new_link: 'Ottieni un nuovo link e continua',
        check_details: 'Controlla prima i miei dati',
      },
      action_needed: {
        title: "{{provider}} ha bisogno di un'altra informazione",
        description:
          '{{provider}} non è riuscito a verificare uno dei dati forniti. Riapri il loro modulo per correggerlo.',
        cta: 'Riapri il modulo {{provider}}',
      },
    },
    connected: {
      title: 'I pagamenti passano tramite {{name}}',
      description: "Questo ristorante è collegato all'account {{name}} — non c'è altro da configurare qui.",
      failed: 'Non siamo ancora riusciti a collegare questo ristorante a {{name}}',
    },
    errors: {
      generic: 'Qualcosa è andato storto. Riprova.',
      load_failed: 'Non è stato possibile caricare la configurazione dei pagamenti di questo ristorante.',
    },
  },
  bank_account: {
    section: {
      title: 'Conto bancario per i pagamenti',
      description: 'I pagamenti vengono inviati in {{currency}}, la valuta in cui questo ristorante incassa.',
    },
    done: 'Torna alla dashboard',
    load_failed: 'Non è stato possibile caricare il conto bancario di questo ristorante.',
    retry: 'Riprova',
    no_permission: 'Solo il titolare del ristorante o il partner può inserire il conto bancario.',
    confirm_with_provider: 'Conferma con Adyen',
    toasts: {
      save_failed: 'Non è stato possibile salvare il conto bancario. Controlla i dati.',
    },
  },
  payouts: {
    finish_setup: 'Completa la configurazione',
  },
};
